import axios from 'axios';
import api from '../../../services/api'
import moment from 'moment'


const base_url = 'https://api.contaazul.com/v1'

const valida_token = async (token) => {
    try {
        const res = await axios.get(`${base_url}/product-categories`, {
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
        return true
    } catch (err) {
        return false
    }
}

export const refresh_token = async (contaazul) => {
    const valida = await valida_token(contaazul.access_token)
    console.log(contaazul)
    console.log(valida)
    if (valida == false) {
        console.log('vai validar')
        const res = await axios.post(`https://api.contaazul.com/oauth2/token?grant_type=refresh_token&refresh_token=${contaazul.refresh_token}`, {
            headers: {
                'Authorization': 'Basic ' + contaazul.client_id,
                'content-type': 'text/plain'
            }
        })
        console.log('res', res)
        const new_contaazul = {
            access_token: res.data.access_token,
            refresh_token: res.data.refresh_token,
            client_id: contaazul.client_id
        }
        console.log(new_contaazul)
        const res_hub = await api.put("/conta_azul/1/", new_contaazul)
        return new_contaazul
    }
    delete contaazul['id']
    return contaazul
}


// WEBPACK FOOTER //
// ./src/pages/ContaAzul/services/refresh_token.js